<template>
  <el-card class="box-card">
    <TagDigitalImage ref="digitalImage" />
    <div slot="header" class="clearfix">
      Objetos
      <span class="post-header__meta">
        <span class="post-header__count">{{ totalFmt }}</span>
        <template v-if="panoramaFmt"> de {{ panoramaFmt }}</template>
        registros
      </span>
      <el-button style="float: right" size="mini" icon="el-icon-plus" type="primary"
        @click="$router.replace({ name: 'prepost.add' })">Nova Pré-postagem</el-button>
    </div>


    <el-dialog title="Imprimir Etiquetas (10x15)" center :visible.sync="print.dialog">
      <el-form>
        <el-form-item>
          <el-radio v-model="print.model" label="0">Zebra<br />
            <img src="/img/zebra4x1.png" style="margin-left: 23px" /></el-radio>
          <el-radio v-model="print.model" label="1">1 por folha<br />
            <img src="/img/etiqueta4x1.png" style="margin-left: 28px" /></el-radio>
          <el-radio v-model="print.model" label="2">2 por folha<br />
            <img src="/img/etiqueta4x2.png" style="margin-left: 28px" /></el-radio>
          <el-radio v-model="print.model" label="4">4 por folha<br />
            <img src="/img/etiqueta4x4.png" style="margin-left: 28px" /></el-radio>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="print.warning" autocomplete="off">Imprimir Aviso Recebimento</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="print.declared" autocomplete="off">Imprimir Declaração Conteudo</el-checkbox>
          <el-radio :disabled="!print.declared" v-model="print.type" label="1">Para todas as etiquetas</el-radio>
          <el-radio :disabled="!print.declared" v-model="print.type" label="2">Somente que possuem declaração</el-radio>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="print.separator" autocomplete="off">Arquivos separados</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="print.dialog = false">Cancelar</el-button>
        <el-button type="primary" @click="doprintall">Imprimir</el-button>
      </span>
    </el-dialog>

    <!-- Mais filtros: seções temáticas, clique fora fecha, Enter aplica -->
    <el-drawer title="Mais filtros" :visible.sync="dialog.filter" direction="rtl" custom-class="demo-drawer"
      ref="drawer" size="560px" :wrapperClosable="true" :append-to-body="true" :modal-append-to-body="false"
      :modal="true">
      <div class="demo-drawer__content" @keydown.enter="applyDrawer">
        <el-form :model="filter" label-position="top" size="mini" class="drawer-form">
          <div class="drawer-section-title">Destinatário</div>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="Nome do destinatário">
                <el-input v-model="filter.name" autocomplete="off" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="CEP">
                <el-input v-model="filter.zipcode" autocomplete="off" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="Estado">
                <el-select v-model="filter.state" filterable>
                  <el-option key="" label="Todos" value=""></el-option>
                  <el-option key="AC" label="Acre" value="AC"></el-option>
                  <el-option key="AL" label="Alagoas" value="AL"></el-option>
                  <el-option key="AP" label="Amapá" value="AP"></el-option>
                  <el-option key="AM" label="Amazonas" value="AM"></el-option>
                  <el-option key="BA" label="Bahia" value="BA"></el-option>
                  <el-option key="CE" label="Ceará" value="CE"></el-option>
                  <el-option key="DF" label="Distrito Federal" value="DF"></el-option>
                  <el-option key="ES" label="Espírito Santo" value="ES"></el-option>
                  <el-option key="GO" label="Goiás" value="GO"></el-option>
                  <el-option key="MA" label="Maranhão" value="MA"></el-option>
                  <el-option key="MT" label="Mato Grosso" value="MT"></el-option>
                  <el-option key="MS" label="Mato Grosso do Sul" value="MS"></el-option>
                  <el-option key="MG" label="Minas Gerais" value="MG"></el-option>
                  <el-option key="PA" label="Pará" value="PA"></el-option>
                  <el-option key="PB" label="Paraíba" value="PB"></el-option>
                  <el-option key="PR" label="Paraná" value="PR"></el-option>
                  <el-option key="PE" label="Pernambuco" value="PE"></el-option>
                  <el-option key="PI" label="Piauí" value="PI"></el-option>
                  <el-option key="RJ" label="Rio de Janeiro" value="RJ"></el-option>
                  <el-option key="RN" label="Rio Grande do Norte" value="RN"></el-option>
                  <el-option key="RS" label="Rio Grande do Sul" value="RS"></el-option>
                  <el-option key="RO" label="Rondônia" value="RO"></el-option>
                  <el-option key="RR" label="Roraima" value="RR"></el-option>
                  <el-option key="SC" label="Santa Catarina" value="SC"></el-option>
                  <el-option key="SP" label="São Paulo" value="SP"></el-option>
                  <el-option key="SE" label="Sergipe" value="SE"></el-option>
                  <el-option key="TO" label="Tocantins" value="TO"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="drawer-section-title">Referências</div>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="Nota">
                <el-input v-model="filter.invoice" autocomplete="off" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Pedido">
                <el-input v-model="filter.request" autocomplete="off" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="Ordem serviço">
                <el-input v-model="filter.orderservice" autocomplete="off" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="O.S. Gerada">
                <el-select v-model="filter.os">
                  <el-option key="2" label="Todos" value="2"></el-option>
                  <el-option key="1" label="Sim" value="1"></el-option>
                  <el-option key="0" label="Não" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="Contrato">
                <el-input v-model="filter.contract" autocomplete="off" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Cartão postagem">
                <el-input v-model="filter.cardpost" autocomplete="off" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="Departamento">
                <el-input v-model="filter.department" autocomplete="off" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="drawer-section-title">Entrega e prazo</div>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item>
                <span slot="label"><i class="el-icon-alarm-clock" style="margin-right: 5px; vertical-align: middle"></i><span style="vertical-align: middle">Prazo</span></span>
                <el-radio-group v-model="filter.deadline">
                  <el-radio label="1" @click.native.prevent="toggleTri('deadline', '1')">Com atraso</el-radio>
                  <el-radio label="0" @click.native.prevent="toggleTri('deadline', '0')">Sem atraso</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Tipo de postagem">
                <el-radio-group v-model="filter.reverse">
                  <el-radio label="1" @click.native.prevent="toggleTri('reverse', '1')">Postagem</el-radio>
                  <el-radio label="0" @click.native.prevent="toggleTri('reverse', '0')">Reversas</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item>
                <span slot="label"><i class="el-icon-truck" style="margin-right: 5px; vertical-align: middle"></i><span style="vertical-align: middle">Coletado</span></span>
                <el-radio-group v-model="filter.collected">
                  <el-radio label="1" @click.native.prevent="toggleTri('collected', '1')">Sim</el-radio>
                  <el-radio label="0" @click.native.prevent="toggleTri('collected', '0')">Não</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <span slot="label"><i class="el-icon-printer" style="margin-right: 5px; vertical-align: middle"></i><span style="vertical-align: middle">Impresso</span></span>
                <el-radio-group v-model="filter.printed">
                  <el-radio label="1" @click.native.prevent="toggleTri('printed', '1')">Sim</el-radio>
                  <el-radio label="0" @click.native.prevent="toggleTri('printed', '0')">Não</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="Motorista">
                <UserDriverList v-model="filter.driver" :current="filter.driver" autocomplete="off" />
              </el-form-item>
            </el-col>
          </el-row>

          <div class="drawer-section-title">Serviços e características</div>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="A.R.">
                <el-radio-group v-model="filter.register">
                  <el-radio label="1" @click.native.prevent="toggleTri('register', '1')">Sim</el-radio>
                  <el-radio label="0" @click.native.prevent="toggleTri('register', '0')">Não</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="AR-E">
                <el-radio-group v-model="filter.digital">
                  <el-radio label="1" @click.native.prevent="toggleTri('digital', '1')">Sim</el-radio>
                  <el-radio label="0" @click.native.prevent="toggleTri('digital', '0')">Não</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="Serviço ECT">
                <el-radio-group v-model="filter.couriers">
                  <el-radio label="1" @click.native.prevent="toggleTri('couriers', '1')">Sim</el-radio>
                  <el-radio label="0" @click.native.prevent="toggleTri('couriers', '0')">Não</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="user.type === '1' || user.type === '3'">
              <el-form-item label="Malha">
                <el-radio-group v-model="filter.malha">
                  <el-radio label="1" @click.native.prevent="toggleTri('malha', '1')">Sim</el-radio>
                  <el-radio label="0" @click.native.prevent="toggleTri('malha', '0')">Não</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12" v-if="user.type === '1' || user.type === '3'">
              <el-form-item>
                <span slot="label"><i class="el-icon-check" style="margin-right: 5px; vertical-align: middle"></i><span style="vertical-align: middle">CD Malha</span></span>
                <el-radio-group v-model="filter.hasmalha">
                  <el-radio label="1" @click.native.prevent="toggleTri('hasmalha', '1')">Passou</el-radio>
                  <el-radio label="0" @click.native.prevent="toggleTri('hasmalha', '0')">Não passou</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="user.type === '1'">
              <el-form-item>
                <span slot="label"><i class="fa fa-balance-scale" style="margin-right: 5px; font-size: .9em; vertical-align: middle"></i><span style="vertical-align: middle">Balança Parceiro</span></span>
                <el-radio-group v-model="filter.balance">
                  <el-radio label="1" @click.native.prevent="toggleTri('balance', '1')">Passou</el-radio>
                  <el-radio label="0" @click.native.prevent="toggleTri('balance', '0')">Não passou</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12" v-if="user.type === '1' || user.type === '3'">
              <el-form-item>
                <span slot="label"><i class="el-icon-top" style="margin-right: 5px; vertical-align: middle"></i><span style="vertical-align: middle">Troca pela malha</span></span>
                <el-radio-group v-model="filter.serviceSwapped">
                  <el-radio label="1" @click.native.prevent="toggleTri('serviceSwapped', '1')">Sim</el-radio>
                  <el-radio label="0" @click.native.prevent="toggleTri('serviceSwapped', '0')">Não</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <template v-if="user.type === '1' || user.type === '3'">
            <div class="drawer-section-title">Gestão</div>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="Ignorar clientes das franquia">
                  <el-radio-group v-model="filter.ignore">
                    <el-radio :label="1">Sim</el-radio>
                    <el-radio :label="0">Não</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label=" ">
                  <el-checkbox v-model="filter.branchs">Incluir filiais do cliente</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </template>

          <div class="drawer-section-title">Observação</div>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item>
                <el-input v-model="filter.observation" type="textarea" :rows="2" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button size="small" @click="dialog.filter = false">Cancelar</el-button>
          <el-button size="small" type="info" @click="$refs.drawer.closeDrawer(); clear();">Limpar filtros</el-button>
          <el-button size="small" type="primary" icon="el-icon-search" @click="applyDrawer()">Filtrar</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- Filtros (flat, sem card): 1ª linha período+ações; 2ª agrupamentos; 3ª campos -->
    <div class="post-filters">
      <!-- Linha 1: período + agrupamentos de status (fases e grupos SRO) -->
      <div class="post-filter-head">
        <!-- Período: o rótulo é o seletor do campo de data (texto, sem moldura) -->
        <div class="post-period-group">
          <el-dropdown trigger="click" @command="changeSearchFor">
            <span class="post-period-mode">
              {{ searchForLabel }} <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="creation" :class="{ 'post-mode-active': filter.searchFor === 'creation' }">
                <i class="el-icon-circle-plus-outline"></i> Período de Criação
              </el-dropdown-item>
              <el-dropdown-item command="posted" :class="{ 'post-mode-active': filter.searchFor === 'posted' }">
                <i class="el-icon-position"></i> Período de Postagem
              </el-dropdown-item>
              <el-dropdown-item command="aferido" :class="{ 'post-mode-active': filter.searchFor === 'aferido' }">
                <i class="el-icon-check"></i> Período de Aferição
              </el-dropdown-item>
              <el-dropdown-item command="coleta" :class="{ 'post-mode-active': filter.searchFor === 'coleta' }">
                <i class="el-icon-truck"></i> Período de Coleta
              </el-dropdown-item>
              <el-dropdown-item v-if="user.type === '1'" command="balance"
                :class="{ 'post-mode-active': filter.searchFor === 'balance' }">
                <i class="fa fa-balance-scale" style="font-size: .9em"></i> Período de Balança
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-date-picker v-model="ruleForm.range" type="daterange" align="right" unlink-panels clearable
            range-separator="à" format="dd/MM/yyyy" start-placeholder="Inicio" end-placeholder="Fim"
            :picker-options="pickerOptions" class="post-period-range"></el-date-picker>
        </div>
        <div class="post-filter-actions">
          <el-button type="primary" icon="el-icon-search" @click="fetchRecords">Filtrar</el-button>
          <!-- Mais filtros: só ícone (badge = filtro ativo no drawer) -->
          <el-badge is-dot :hidden="hasfilter" class="post-more-filters">
            <el-button icon="el-icon-s-operation" title="Mais filtros" @click="dialog.filter = true"></el-button>
          </el-badge>
        </div>
      </div>
      <!-- Linha 2: agrupamentos ampliados (Fase | Situação | Financeiro) -->
      <div class="post-filter-clusters">
        <PostStatusDistribution :segments="distribution" :total="tabCount(tabsConfig.all)" :active="activeTab"
          :selected="filter.statuses" @select="setTab" />
        <!-- Totais financeiros do filtro: mesmo desenho dos cards, sem borda
             (não é clicável) -->
        <div class="post-kpis">
          <div class="post-kpis__title">Financeiro</div>
          <div class="post-kpis__items">
            <div class="post-kpi">
              <i class="el-icon-money post-kpi__icon"></i>
              <span class="post-kpi__info">
                <span class="post-kpi__value">{{ currency(pricetable) }}</span>
                <span class="post-kpi__label">{{ user.type !== '2' && user.type !== '5' ? 'Venda' : 'Valor' }}</span>
              </span>
            </div>
            <template v-if="user.type !== '2' && user.type !== '5'">
              <div class="post-kpi">
                <i class="el-icon-coin post-kpi__icon"></i>
                <span class="post-kpi__info">
                  <span class="post-kpi__value">{{ currency(courier) }}</span>
                  <span class="post-kpi__label">Custo</span>
                </span>
              </div>
              <div class="post-kpi post-kpi--margin">
                <i class="el-icon-data-line post-kpi__icon"></i>
                <span class="post-kpi__info">
                  <span class="post-kpi__value">{{ margin }}%</span>
                  <span class="post-kpi__label">Margem</span>
                </span>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- Linha 3: campos de filtro (tamanhos padronizados) -->
      <el-form :model="ruleForm" :inline="true" ref="ruleForm">
        <div class="post-filter-fields">
            <el-form-item prop="tag">
              <span slot="label">
                {{ $t("objeto") }}
                <el-tooltip placement="top">
                  <div slot="content">
                    Separe vários códigos por <b>;</b> vírgula ou espaço.<br />
                    <b>Enter</b> pesquisa &middot; <b>Esc</b> limpa
                  </div>
                  <i class="el-icon-info post-tag-info"></i>
                </el-tooltip>
              </span>
              <el-input v-model="filter.tag" placeholder="MASV123456789000BR; MASV987654321000BR" clearable
                class="uppercase post-tag-input" @keydown.native="onTagKey" />
            </el-form-item>
            <el-form-item :label="$t('servico')" prop="name">
              <ServicesList v-model="ruleForm.services" :multiple="true" />
            </el-form-item>
            <el-form-item :label="user.type === '1' || user.type === '3' ? $t('cliente') : $t('filial')" prop="name"
              v-if="user.type !== '5'">
              <CustomerList v-model="ruleForm.customer" :current="ruleForm.customer" v-bind:multiple="true"
                v-bind:customerType="user.type === '2' ? 3 : 0" />
            </el-form-item>
            <el-form-item :label="$t('status')" prop="statuses">
              <!-- Os chips abaixo são presets deste campo: clicar num grupo preenche os status aqui -->
              <el-select v-model="filter.statuses" multiple clearable collapse-tags :placeholder="$t('todas')"
                class="post-status-select" @change="onStatusesChange">
                <el-option-group v-for="group in statusGroups" :key="group.key" :label="group.label">
                  <el-option v-for="status in group.statuses" :key="status" :label="statusLabel(status)"
                    :value="String(status)">
                    <el-tag size="mini" :type="statusTagType(status)" disable-transitions>{{ statusLabel(status) }}</el-tag>
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
        </div>
      </el-form>
    </div>



    <PrepostEdit
      v-if="rowModal.open"
      :tag="rowModal.tag"
      :dialog="rowModal.open"
      :state="rowModalState"
      :tab="rowModalTab"
      v-on:close="closeRowModal()"
    />
    <PrepostDCEdit ref="dcEdit" />
    <!-- Diálogo único de notificação WhatsApp (a etiqueta troca por linha) -->
    <NotificationTag ref="notification" :tag="notificationTag" />
    <!-- Ações em massa sobre os objetos selecionados (XML usa só as pré) -->
    <!-- Ações em massa: só aparecem com objetos selecionados (XML usa só as pré) -->
    <div v-if="selected.length > 0" class="post-mass-actions">
      <span class="post-mass-actions__hint">{{ selected.length }} selecionado(s)</span>
      <el-button type="text" icon="el-icon-notebook-2" @click="plp()">XML Sara</el-button>
      <el-button type="text" icon="el-icon-printer" @click="printall()">Imprimir</el-button>
    </div>
    <el-table @row-dblclick="openRowEdit" @selection-change="onSelectionChange" :data="tableData" stripe
      ref="tablePrepost" size="mini" style="width: 100%"
      class="post-table" :default-sort="{ prop: 'name', order: 'ascending' }">
      <el-table-column type="selection" :selectable="canSelectRow" width="50"></el-table-column>
      <el-table-column v-if="cols.occurrences" label="Ocorrências" width="120" align="center">
        <div slot-scope="scope" style="display: flex; gap: 2px;">
          <span class="occurrence-icon">
            <i v-if="scope.row.print.printer" class="el-icon-printer"
              :title="`Etiqueta impressa ${scope.row.print.count} vez(es), última impressão em ${scope.row.print.printedAt}`"></i>
          </span>
          <span class="occurrence-icon">
            <i v-if="scope.row.gauged" class="el-icon-check" title="Objeto aferido na unidade"></i>
          </span>
          <span class="occurrence-icon">
            <i v-if="scope.row.collected" class="el-icon-truck" title="Objeto coletado"></i>
          </span>
          <span class="occurrence-icon">
            <i v-if="scope.row.balance" class="fa fa-balance-scale" title="Balança Parceiro"></i>
          </span>
          <span class="occurrence-icon">
            <i v-if="scope.row.receivedCd" class="el-icon-circle-check" title="Reversa Consolidada recebida em nosso CD"></i>
          </span>
          <span class="occurrence-icon">
            <i v-if="scope.row.imageDigital" class="el-icon-picture" title="AR Digital/Eletrônico" @click="showDigital(scope.row.tag)" style="margin-left: 4px ;cursor: pointer"></i>
          </span>
          <span class="occurrence-icon">
            <!-- Prazo: vermelho suave só quando atrasado -->
            <i v-if="scope.row.expectedAt" class="el-icon-alarm-clock post-deadline-icon"
              :class="{ 'post-deadline-icon--late': scope.row.late }" :title="deadlineHint(scope.row)"></i>
          </span>
        </div>
      </el-table-column>
      <el-table-column sortable width="190" prop="tag" :label="$t('objeto')">
        <template slot-scope="scope">
          <TagLink :tag="scope.row.tag" :back="'post'" :notification="scope.row.notification"
            :editable="isPreRow(scope.row)" :whatsapp="false" />
        </template>
      </el-table-column>
      <el-table-column sortable prop="customer" min-width="140" show-overflow-tooltip v-if="user.type !== '5'"
        :label="user.type !== '2' ? 'Cliente' : 'Filial'">
        <template slot-scope="scope">
          <!-- Departamento vira só a inicial (hover mostra o nome completo) -->
          <span v-if="scope.row.department" class="post-dept-badge" :title="`Departamento: ${scope.row.department}`">
            {{ scope.row.department.charAt(0).toUpperCase() }}
          </span>
          {{ scope.row.customer }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="name" label="Dest. Nome" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column v-if="cols.destiny" sortable prop="destiny" label="Destino" width="90"></el-table-column>
      <el-table-column prop="service" sortable :label="$t('servico')" min-width="130" show-overflow-tooltip />
      <el-table-column v-if="cols.invoice" sortable prop="invoice" label="NF" width="90" show-overflow-tooltip />
      <el-table-column sortable prop="value" label="Custo" width="95" v-if="cols.value && user.type !== '2' && user.type !== '5'">
        <template slot-scope="scope">
          {{
            scope.row.value
            | currency("R$ ", 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
            })
          }}
        </template>
      </el-table-column>
      <el-table-column v-if="cols.pricetable" sortable prop="pricetable"
        :label="user.type !== '2' && user.type !== '5' ? 'Venda' : 'Valor'" width="95">
        <template slot-scope="scope">
          {{
            scope.row.pricetable
            | currency("R$ ", 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
            })
          }}
        </template>
      </el-table-column>
      <el-table-column v-if="cols.createdAt" prop="createdAt" label="Criação" width="95" sortable />
      <el-table-column v-if="cols.postedAt" prop="postedAt" label="Postagem" width="95" sortable />
      <el-table-column :label="$t('status')" min-width="100">
        <template slot-scope="scope">
          <!-- Mesmo comportamento do clique na etiqueta: modal na aba Rastreio -->
          <el-tooltip placement="top"
            :content="`${rowStatusLabel(scope.row)}${scope.row.statuscourier && scope.row.statuscourier !== rowStatusLabel(scope.row) ? ' — ' + scope.row.statuscourier : ''}`">
            <el-tag size="mini" :type="statusTagType(scope.row.status)" class="post-status-tag"
              @click.native="openTracking(scope.row)">
              {{ rowStatusLabel(scope.row) }}
            </el-tag>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="#" width="145" fixed="right">
        <template slot-scope="scope">
          <div class="post-actions">
            <span class="post-action-slot">
              <i v-if="isPreRow(scope.row) && !scope.row.plp && (scope.row.status === '10' || !scope.row.print.printer)"
                class="el-icon-delete post-action-icon post-action-icon--danger"
                title="Excluir/cancelar pré-postagem" @click="removeRow(scope.row.id, scope.row.tag)"></i>
            </span>
            <span class="post-action-slot">
              <i v-if="isPreRow(scope.row) && scope.row.status !== '10'"
                class="el-icon-tickets post-action-icon post-action-icon--info"
                title="Editar Declaração de Conteúdo" @click="dc(scope.row)"></i>
            </span>
            <span class="post-action-slot">
              <i class="fa fa-whatsapp post-action-icon post-action-icon--wa"
                title="Notificação de rastreio por WhatsApp" @click="openWhatsapp(scope.row)"></i>
            </span>
            <span class="post-action-slot">
              <i v-if="scope.row.status !== '10'" class="el-icon-document post-action-icon"
                title="Comprovante de postagem" @click="proof(scope.row)"></i>
            </span>
            <span class="post-action-slot">
              <i v-if="scope.row.status !== '10'" class="el-icon-printer post-action-icon post-action-icon--primary"
                title="Imprimir essa etiqueta" @click="printsingle(scope.row)"></i>
            </span>
            <span class="post-action-slot">
              <i class="el-icon-edit-outline post-action-icon post-action-icon--warning" title="Detalhes do objeto"
                @click="editRow(scope.row)"></i>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="bottom clearfix">
      <el-row :gutter="5">
        <el-col :lg="8">
          <el-pagination :page-size="filter.records" background @current-change="fetchRecords"
            @size-change="changeSize" :current-page.sync="filter.page" layout="sizes, prev, pager, next" :page-sizes="[
              50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000,
            ]" :total="total" v-show="total > 0"></el-pagination>
        </el-col>
        <el-col :lg="8" style="margin-top: 2px; float: right">
          <el-dropdown>
            <el-button>
              Exportar
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><span @click=" doexport('csv')">CSV</span></el-dropdown-item>
              <el-dropdown-item><span @click=" doexport('xls')">XLS</span></el-dropdown-item>
              <el-dropdown-item><span @click=" doexport('html')">HTML</span></el-dropdown-item>
              <el-dropdown-item><span @click=" doexport('xml')">XML</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>
<script>
import { PostService } from "@/services/customers/post.services";
import { PrepostService } from "@/services/customers/prepost.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ServicesList from "@/xpost/views/register/services/ServicesList";
import UserDriverList from "@/xpost/views/register/user/UserDriverList";
import PrepostEdit from "@/xpost/views/services/pre.post/PrePostEdit.vue";
import TagDigitalImage from './components/TagDigitalImage';
import PrepostDCEdit from "@/xpost/views/services/pre.post/components/PrePostDCEdit.vue";
import PostStatusDistribution from './components/PostStatusDistribution.vue';
import moment from "moment";
import "moment/locale/pt-br";
import TagLink from "../../dashboard/prepost/components/TagLink.vue";
import NotificationTag from "../../dashboard/prepost/components/NotificationTag.vue";
import RowModalMixin from "@/xpost/mixins/row-modal";
import { i18n } from "@/plugin/i18n";
import { OPEN_PRE_STATUS_OPTIONS, PRE_STATUS_OPTIONS, ALL_STATUS_OPTIONS, POST_STATUS_OPTIONS, STATUS_GROUPS, statusLabel, rowStatusLabel, statusTagType } from "@/xpost/helpers/prepost-status";

const GROUPS = {};
STATUS_GROUPS.forEach((group) => { GROUPS[group.key] = group; });
const groupTab = (key) => ({
  label: GROUPS[key].label,
  statuses: GROUPS[key].statuses,
  icon: GROUPS[key].icon,
  color: GROUPS[key].color,
});
const TABS = {
  all: { label: "Todas", statuses: [] },
  pre: { ...groupTab("pre"), statuses: PRE_STATUS_OPTIONS.map(String) },
  post: { label: "Postadas", statuses: POST_STATUS_OPTIONS.map(String), icon: "el-icon-position" },
  progress: groupTab("progress"),
  attention: groupTab("attention"),
  delivered: groupTab("delivered"),
  canceled: groupTab("canceled"),
};

export default {
  mixins: [RowModalMixin],
  name: "PostList",
  props: {
    range: Array,
    customer: String,
    service: String,
  },
  components: {
    TagLink,
    NotificationTag,
    CustomerList,
    ServicesList,
    PrepostEdit,
    UserDriverList,
    PostStatusDistribution,
    TagDigitalImage,
    PrepostDCEdit,
  },
  computed: {
    tableDataList() {
      const vm = this;
      return vm.tableData;
    },
    tabsConfig() {
      return TABS;
    },
    cols() {
      const width = this.windowWidth;
      return {
        destiny: width > 1490,
        invoice: width > 1440,
        postedAt: width > 1340,
        value: width > 1290,
        pricetable: width > 1190,
        createdAt: width > 1140,
        occurrences: width > 1020,
      };
    },
    searchForLabel() {
      const labels = {
        creation: "Período de Criação",
        posted: "Período de Postagem",
        aferido: "Período de Aferição",
        coleta: "Período de Coleta",
        balance: "Período de Balança",
      };
      return labels[this.filter.searchFor] || labels.creation;
    },
    margin() {
      if (!this.pricetable) return 0;
      return +(((this.pricetable - this.courier) / this.pricetable) * 100).toFixed(1);
    },
    // Filtrado × panorama: total filtrado em destaque; "de Y" só com filtro ativo
    totalFmt() {
      return (+this.total || 0).toLocaleString("pt-BR");
    },
    panoramaFmt() {
      if (+this.summary.total > +this.total) {
        return (+this.summary.total).toLocaleString("pt-BR");
      }
      return "";
    },
    // Segmentos da barra de distribuição (um por grupo, menos "Todas")
    distribution() {
      const vm = this;
      return Object.keys(vm.tabsConfig)
        .filter((key) => key !== "all")
        .map((key) => ({
          key,
          label: vm.tabsConfig[key].label,
          count: vm.tabCount(vm.tabsConfig[key]),
          color: vm.tabsConfig[key].color || "#c0c4cc",
          icon: vm.tabsConfig[key].icon || "el-icon-collection-tag",
          cluster: key === "pre" || key === "post" ? "fase" : "situacao",
          statuses: vm.tabsConfig[key].statuses,
        }));
    },
    hasfilter() {
      const vm = this;
      return !(
        vm.filter.tag ||
        vm.filter.contract ||
        vm.filter.cardpost ||
        vm.filter.register !== "2" ||
        vm.filter.digital !== "2" ||
        vm.filter.invoice ||
        vm.filter.orderservice ||
        vm.filter.departament ||
        vm.filter.request ||
        vm.filter.plp ||
        vm.filter.zipcode ||
        vm.filter.state ||
        vm.filter.name ||
        vm.filter.deadline !== "2" ||
        vm.filter.collected !== "2" ||
        vm.filter.couriers !== "2" ||
        vm.filter.hasplp !== "2" ||
        vm.filter.printed !== "2" ||
        vm.filter.hasmalha !== '2' ||
        vm.filter.serviceSwapped !== "2" ||
        vm.filter.balance !== '2' ||
        vm.filter.observation
      );
    },
  },
  data() {
    return {
      total: 0,
      rowModalTab: "edit",
      notificationTag: "",
      selected: [],
      windowWidth: window.innerWidth,
      rowModalState: "VIEW",
      statusGroups: STATUS_GROUPS,
      print: {
        model: '4',
        warning: true,
        declared: true,
        type: '1',
        dialog: false,
        separator: false,
      },
      filter: {
        tag: "",
        contract: "",
        cardpost: "",
        department: "",
        status: 0,
        register: "2",
        digital: "2",
        invoice: "",
        orderservice: "",
        plp: "",
        zipcode: "",
        state: "",
        name: "",
        request: '',
        ignore: 0,
        deadline: "2",
        collected: "2",
        printed: '2',
        couriers: "2",
        hasplp: "2",
        malha: "2",
        reverse: "2",
        hasmalha: "2",
        serviceSwapped: "2",
        balance: "2",
        observation: "",
        records: 50,
        driver: "",
        page: 1,
        branchs: false,
        searchFor: "creation",
        byCreationDate: true,
        os: "2",
        statuses: [],
        delivery: false,
      },
      summary: { loading: false, total: 0, byStatus: [] },
      activeTab: "all",
      ready: false,
      tableData: [],
      dialog: {
        filter: false,
      },
      pricetable: 0,
      courier: 0,
      pickerOptions: {
        shortcuts: [
          { text: "Hoje", onClick(picker) { const day = new Date(); picker.$emit("pick", [day, day]); } },
          {
            text: "Últimos 7 dias",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(start.getDate() - 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Últimos 15 dias",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(start.getDate() - 15);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Últimos 30 dias",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(start.getDate() - 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Últimos 90 dias",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(start.getDate() - 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Este mês",
            onClick(picker) {
              const end = new Date();
              picker.$emit("pick", [new Date(end.getFullYear(), end.getMonth(), 1), end]);
            },
          },
          {
            text: "Mês passado",
            onClick(picker) {
              const day = new Date();
              const start = new Date(day.getFullYear(), day.getMonth() - 1, 1);
              const end = new Date(day.getFullYear(), day.getMonth(), 0);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      user: {
        type: "1",
        name: "",
      },
      formPrepost: {
        object: "",
        contract: "",
        orderservice: "",
        plp: "",
        destinatary: "",
        zipcode: "",
      },
      ruleForm: {
        range: [new Date().setDate(new Date().getDate() - 3), new Date()],
        customer: "",
        services: "",
      },
    };
  },
  watch: {
    $route(to) {
      const vm = this;
      vm.ready = false;
      vm.applyRoute(to);
      vm.ready = true;
      vm.fetchRecords();
    },
    activeTab(tab) {
      const config = this.tabsConfig[tab];
      if (!config) return;
      this.filter.statuses = config.statuses;
      this.filter.page = 1;
      if (this.ready) this.fetchRecords();
    },
  },
  methods: {
    nfeNumber(row) {
      let nfe = row.nfe;
      try {
        if (typeof nfe === "string") nfe = JSON.parse(nfe);
      } catch (e) {
        nfe = null;
      }
      return (nfe && (nfe.number || nfe.nfeNumber)) || row.invoice || "";
    },
    setTab(tab) {
      this.activeTab = tab;
    },
    openWhatsapp(row) {
      this.notificationTag = row.tag;
      this.$nextTick(() => this.$refs.notification.open());
    },
    onSelectionChange(selection) {
      this.selected = selection;
    },
    // Radios de dois estados: clicar no já selecionado limpa o filtro
    // (volta ao neutro "2", o antigo "Ambos")
    toggleTri(field, value) {
      this.filter[field] = this.filter[field] === value ? "2" : value;
    },
    // Enter dentro do drawer aplica o filtro (menos no textarea de observação)
    applyDrawer(event) {
      if (event && event.target && event.target.tagName === "TEXTAREA") return;
      this.$refs.drawer.closeDrawer();
      this.fetchRecords();
    },
    openRowEdit(row, column, event) {
      this.rowModalTab = "edit";
      this.rowModalState = "VIEW";
      this.openRowModal(row, column, event);
    },
    openTracking(row) {
      if (!row || !row.tag) return;
      this.rowModalTab = "tracking";
      this.rowModalState = "VIEW";
      this.rowModal = { tag: row.tag, open: true };
    },
    editRow(row) {
      this.rowModalTab = "edit";
      this.rowModalState = this.isPreRow(row) ? "" : "VIEW";
      this.rowModal = { tag: row.tag, open: true };
    },
    dc(row) {
      this.$refs.dcEdit.open(row.id);
    },
    removeRow(id, name) {
      const vm = this;
      this.$confirm(i18n.t("confirmar-eliminacao-prepostagem", { id: name }), i18n.tc("aviso"), {
        confirmButtonText: "OK",
        cancelButtonText: i18n.tc("cancelar"),
        type: i18n.tc("aviso"),
        center: true,
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        PrepostService.delete(id)
          .then(() => {
            vm.tableData.splice(vm.tableData.findIndex((x) => x.id === id), 1);
            vm.total -= 1;
            vm.fetchSummary();
            this.$message({ type: "success", duration: 5000, message: "Pré-postagem removida com sucesso!" });
          })
          .catch((error) => {
            this.$message({ type: "error", message: error, duration: 5000 });
          })
          .finally(() => loading.close());
      });
    },
    printsingle(row) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PrepostService.print([row.tag], { declared: true, warning: true, model: '1', type: '1' })
        .then((response) => {
          const downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `${row.tag}.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => {
          this.$message({ type: "error", message: error });
        })
        .finally(() => loading.close());
    },
    proof(row) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PrepostService.proof(row.tag)
        .then((response) => {
          const downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `${row.tag}-comprovante.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => {
          this.$message({ type: "error", message: error });
        })
        .finally(() => loading.close());
    },
    currency(value) {
      return (+value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
    // Atalhos do campo Objeto (mesmos da consulta SRO): Enter pesquisa, Esc limpa
    onTagKey(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        this.fetchRecords();
      }
      if (event.key === "Escape") {
        event.preventDefault();
        this.filter.tag = "";
      }
    },
    statusLabel(status) {
      return statusLabel(status);
    },
    rowStatusLabel(row) {
      return rowStatusLabel(row);
    },
    statusTagType(status) {
      return statusTagType(status);
    },
    onStatusesChange(values) {
      const tabs = this.tabsConfig;
      const match = Object.keys(tabs).find(
        (key) => tabs[key].statuses.length === values.length
          && tabs[key].statuses.every((status) => values.includes(String(status)))
      );
      this.activeTab = match || "";
    },
    applyRoute(route) {
      const vm = this;
      const query = route.query || {};
      vm.filter.searchFor = "creation";
      vm.filter.byCreationDate = true;
      vm.filter.page = 1;
      const preset = (route.meta && route.meta.preset) || query.preset;
      if (preset === "pre") {
        vm.activeTab = "pre";
        vm.filter.statuses = vm.tabsConfig.pre.statuses;
      } else if (preset === "post") {
        vm.activeTab = "post";
        vm.filter.statuses = vm.tabsConfig.post.statuses;
      } else {
        vm.activeTab = "all";
        vm.filter.statuses = [];
      }
      if (query.startedAt && query.finishedAt) {
        vm.ruleForm.range = [moment(query.startedAt).toDate(), moment(query.finishedAt).toDate()];
      }
      if (query.customer) {
        vm.ruleForm.customer = Array.isArray(query.customer) ? query.customer : [query.customer];
      }
      if (query.services) {
        vm.ruleForm.services = Array.isArray(query.services) ? query.services : [query.services];
      }
      if (query.tab && vm.tabsConfig[query.tab]) {
        vm.activeTab = query.tab;
        vm.filter.statuses = vm.tabsConfig[query.tab].statuses;
      }
      if (query.statuses) {
        const statuses = Array.isArray(query.statuses) ? query.statuses : [query.statuses];
        vm.filter.statuses = statuses.map(String);
        vm.onStatusesChange(vm.filter.statuses); // sincroniza o chip com o preset
      }
      if (query.state) {
        vm.filter.state = query.state; // atalho do mapa de estados da home
      }
      if (query.byCreationDate === "0" || query.byCreationDate === "false") {
        vm.filter.byCreationDate = false;
        vm.filter.searchFor = "posted";
      }
    },
    deadlineHint(row) {
      const expected = moment(row.expectedAt, "DD/MM/YYYY");
      if (!expected.isValid()) return "";
      const days = expected.startOf("day").diff(moment().startOf("day"), "days");
      if (row.late) {
        return `Atrasada — previsão ${row.expectedAt} (${Math.abs(days)} dia(s) de atraso)`;
      }
      if (days >= 0) {
        return `Previsão ${row.expectedAt} — ${days} dia(s) restante(s)`;
      }
      return `Previsão ${row.expectedAt}`;
    },
    tabCount(tab) {
      if (tab.statuses.length === 0) return this.summary.total;
      return this.summary.byStatus
        .filter((row) => tab.statuses.includes(String(row.status)))
        .reduce((acc, row) => acc + row.total, 0);
    },
    isPreRow(row) {
      return OPEN_PRE_STATUS_OPTIONS.map(String).includes(String(row.status));
    },
    canSelectRow(row) {
      return row.status !== "10";
    },
    // Sem seleção = todos os status (senão o backend cai no universo default)
    buildFilter() {
      const filter = { ...this.filter };
      if (filter.statuses.length === 0) {
        filter.statuses = ALL_STATUS_OPTIONS.map(String);
      }
      return filter;
    },
    plp() {
      const vm = this;
      const rows = vm.$refs.tablePrepost.selection.filter((row) => vm.isPreRow(row));
      if (rows.length == 0) {
        return this.$message({ type: "error", message: "Selecione pré-postagens para gerar o XML!" });
      }
      const loading = vm.$loading(vm.$options.loading);
      PrepostService.plp("", rows)
        .then((response) => {
          this.$message({ type: "success", message: "Arquivo gerado com sucesso!" });
          for (const xml of response) {
            const blob = new Blob([xml.content], { type: "text/plain" });
            var downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = xml.filename;
            document.body.appendChild(downloadLink);
            downloadLink.click();
          }
        })
        .catch((error) => {
          this.$message({ type: "error", message: error });
        })
        .finally(() => loading.close());
    },
    printall() {
      const vm = this;
      if (vm.$refs.tablePrepost.selection.length == 0) {
        return this.$message({ type: "error", message: "Selecione os objetos para impressão!" });
      }
      const tags = vm.$refs.tablePrepost.selection.map((row) => row.tag);
      if (tags.length > 100) {
        return this.$message({ type: "error", message: "Limite máximo para impressão de etiquetas é de 100 etiquetas por vez!" });
      }
      vm.print.dialog = true;
    },
    doprintall() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const tags = vm.$refs.tablePrepost.selection.map((row) => row.tag);
      const markPrinted = () => {
        const today = moment();
        for (const row of vm.$refs.tablePrepost.selection) {
          row.print.printedAt = today.format("DD/MM/YYYY HH:mm:ss");
          row.print.count = row.print.printer ? +row.print.count + 1 : 1;
          row.print.printer = true;
        }
      };
      const service = vm.print.separator
        ? PrepostService.printSeparador(tags, vm.print)
        : PrepostService.print(tags, vm.print);
      service
        .then((response) => {
          vm.print.dialog = false;
          const today = moment();
          const files = vm.print.separator
            ? [
                { href: response.data, name: `etiqueta-${tags.length}-${today.format("YYYY-MM-DD")}.pdf` },
                response.declared && { href: response.declared, name: `etiqueta-dc-${today.format("YYYY-MM-DD")}.pdf` },
                response.warning && { href: response.warning, name: `etiqueta-ar-${today.format("YYYY-MM-DD")}.pdf` },
              ].filter(Boolean)
            : [{ href: response, name: `etiqueta-${tags.length}-${today.format("YYYY-MM-DD")}.pdf` }];
          for (const file of files) {
            var downloadLink = document.createElement("a");
            downloadLink.href = file.href;
            downloadLink.download = file.name;
            document.body.appendChild(downloadLink);
            downloadLink.click();
          }
          markPrinted();
        })
        .catch((error) => {
          this.$message({ type: "error", duration: 5000, message: error });
        })
        .finally(() => loading.close());
    },
    // Resumo ignora aba/atraso para as caixas mostrarem o quadro inteiro do filtro
    fetchSummary() {
      const vm = this;
      const s = moment(vm.ruleForm.range[0]);
      const f = moment(vm.ruleForm.range[1]);
      vm.summary.loading = true;
      PostService.summary(
        vm.ruleForm.customer,
        s.format("YYYY-MM-DD"),
        f.format("YYYY-MM-DD"),
        vm.ruleForm.services,
        { ...vm.buildFilter(), statuses: ALL_STATUS_OPTIONS.map(String), delivery: false, action: undefined }
      )
        .then((response) => {
          vm.summary = { ...vm.summary, ...response };
        })
        .catch(() => {
          vm.summary = { ...vm.summary, total: 0, byStatus: [] };
        })
        .finally(() => {
          vm.summary.loading = false;
        });
    },
    showDigital(tag) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PrepostService.digital(tag)
        .then((response) => {
          vm.$refs.digitalImage.open(response);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    doexport(type) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const s = moment(vm.ruleForm.range[0]);
      const f = moment(vm.ruleForm.range[1]);
      vm.filter.action = "export";
      vm.filter.fileType = type;

      PostService.filter(
        vm.ruleForm.customer,
        s.format("YYYY-MM-DD"),
        f.format("YYYY-MM-DD"),
        vm.ruleForm.services,
        vm.buildFilter()
      )
        .then((response) => {
          this.$message({
            type: "warning",
            message: 'Seu relatório de postagens está sendo gerado, assim que terminar você receberá uma notificação no canto superior direito!',
            duration: 5000,
          });
          vm.$bus.$emit("notifications", response.id);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    changeSize(size) {
      const vm = this;
      vm.filter.records = size;
      vm.fetchRecords();
    },
    open(tag) {
      const vm = this;
      vm.$router.replace({ name: "objects.sro.tag", params: { tag: tag }, query: { back: 'post' } });
    },
    clear() {
      const vm = this;
      vm.filter.tag = "";
      vm.filter.contract = "";
      vm.filter.cardpost = "";
      vm.filter.status = 0;
      vm.activeTab = "all";
      vm.filter.statuses = [];
      vm.filter.register = "2";
      vm.filter.digital = "2";
      vm.filter.hasmalha = "2";
      vm.filter.serviceSwapped = "2";
      vm.filter.balance = "2";
      vm.filter.invoice = "";
      vm.filter.orderservice = "";
      vm.filter.plp = "";
      vm.filter.zipcode = "";
      vm.filter.state = "";
      vm.filter.name = "";
      vm.filter.request = "";
      vm.filter.deadline = "2";
      vm.filter.collected = "2";
      vm.filter.printed = "2";
      vm.filter.couriers = "2";
      vm.filter.hasplp = "2";
      vm.filter.observation = "";
      vm.filter.branchs = false;
      vm.filter.byCreationDate = true;
      vm.filter.searchFor = "creation";
    },
    changeSearchFor(value) {
      this.filter.searchFor = value;
      this.filter.byCreationDate = value === "creation";
      this.fetchRecords();
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const s = moment(vm.ruleForm.range[0]);
      const f = moment(vm.ruleForm.range[1]);
      vm.fetchSummary();

      PostService.filter(
        vm.ruleForm.customer,
        s.format("YYYY-MM-DD"),
        f.format("YYYY-MM-DD"),
        vm.ruleForm.services,
        vm.buildFilter()
      )
        .then((response) => {
          vm.tableData = response.records;
          vm.total = response.total;
          vm.pricetable = +response.pricetable || 0;
          vm.courier = +response.courier || 0;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    copy() {
      this.$message({
        type: "success",
        message: "Objeto copiado com sucesso",
      });
    },
  },
  mounted() {
    const vm = this;
    vm.applyRoute(vm.$route);
    vm.onPrepostRemoved = (id) => {
      const index = vm.tableData.findIndex((x) => x.id === id);
      if (index !== -1) {
        vm.tableData.splice(index, 1);
        vm.total -= 1;
        vm.fetchSummary();
      }
    };
    vm.$bus.$on("prepost-removed", vm.onPrepostRemoved);
    vm.onResize = () => {
      vm.windowWidth = (vm.$el && vm.$el.offsetWidth) || window.innerWidth;
    };
    window.addEventListener("resize", vm.onResize);
    vm.$nextTick(vm.onResize);
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.user.name = response.name;
        vm.ready = true;
        vm.fetchRecords();
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
  beforeDestroy() {
    this.$bus.$off("prepost-removed", this.onPrepostRemoved);
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped>
.post-status-select {
  width: 100%;
}

.post-tag-input {
  width: 100%;
}

.post-more-filters {
  margin-left: 8px;
}

.post-filter-fields {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;
}

.post-filter-fields > .el-form-item {
  display: flex;
  align-items: center;
  flex: 1 1 0;
  min-width: 220px;
  margin-right: 14px;
}

.post-filter-fields > .el-form-item:last-child {
  margin-right: 0;
}

.post-filter-fields >>> .el-form-item__content {
  flex: 1;
}

.post-filter-fields >>> .el-select {
  width: 100%;
}

.post-filter-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
}

@media (max-width: 1500px) {
  .post-kpi--margin {
    display: none;
  }
}

@media (max-width: 1200px) {
  .post-kpis {
    display: none;
  }
}

@media (max-width: 1650px) {
  .post-filter-clusters {
    gap: 10px;
  }

  .post-kpis {
    padding-left: 12px;
  }

  .post-kpi__icon {
    font-size: 18px;
    margin-right: 8px;
  }

  .post-kpi__value {
    font-size: 14px;
  }

  .post-kpi {
    margin-right: 16px;
  }
}

.post-filters {
  margin: 4px 0 2px;
}

.post-filter-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 18px;
}

.post-filter-clusters {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 18px;
  margin: 0 0 18px;
}

.post-period-group {
  display: inline-flex;
  align-items: center;
}

.post-period-mode {
  font-size: 14px;
  font-weight: 600;
  color: #22418d;
  cursor: pointer;
  white-space: nowrap;
  margin-right: 12px;
}

.post-period-range {
  width: 640px !important;
  max-width: 100%;
}

.post-mode-active {
  color: #22418d;
  font-weight: 600;
}

.post-tag-info {
  color: #c0c4cc;
  cursor: help;
}

.post-kpis {
  border-left: 1px solid #ebeef5;
  padding-left: 18px;
  margin-left: 6px;
}

.post-kpis__title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #909399;
  margin-bottom: 6px;
}

.post-kpis__items {
  display: flex;
  flex-wrap: wrap;
}

.post-kpi {
  display: flex;
  align-items: center;
  padding: 8px 0;
  margin-right: 26px;
}

.post-kpi__icon {
  font-size: 22px;
  color: #909399;
  margin-right: 10px;
}

.post-kpi__info {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.post-kpi__value {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
  font-variant-numeric: tabular-nums;
}

.post-kpi__label {
  font-size: 11px;
  color: #909399;
  white-space: nowrap;
}

.post-status-tag {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.post-actions {
  display: flex;
  align-items: center;
  justify-content: end;
}

.post-action-slot {
  display: inline-flex;
  width: 20px;
  justify-content: center;
}

.post-action-icon {
  font-size: 16px;
  color: #606266;
  cursor: pointer;
  vertical-align: middle;
  transition: opacity 0.15s ease;
}

.post-action-icon:hover {
  opacity: 0.65;
}

.post-action-icon--primary,
.post-action-icon--warning {
  color: rgba(34, 65, 141, 0.55);
}

.post-action-icon--danger {
  color: rgba(245, 108, 108, 0.85);
}

.post-action-icon--info {
  color: #909399;
}

.post-action-icon--wa {
  color: #2fb85d;
}

.post-dept-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #eef1f6;
  color: #606266;
  font-size: 10px;
  font-weight: 700;
  margin-right: 5px;
  vertical-align: middle;
  cursor: help;
}

.post-deadline-icon {
  color: #c0c4cc;
  font-size: 14px;
  margin-right: 4px;
  vertical-align: middle;
  cursor: default;
}

.post-deadline-icon--late {
  color: rgba(245, 108, 108, 0.75);
}

.post-table >>> th > .cell {
  white-space: nowrap;
}

/* Drawer Mais filtros: seções no padrão dos clusters + rodapé fixo */
.demo-drawer__content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 16px;
  overflow-x: hidden;
}

.drawer-form {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 8px;
}

.drawer-section-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #909399;
  margin: 14px 0 8px;
  padding-top: 12px;
  border-top: 1px solid #f0f2f5;
}

.drawer-form .drawer-section-title:first-child {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}

.demo-drawer__footer {
  display: flex;
  justify-content: flex-end;
  padding: 12px 0;
  border-top: 1px solid #ebeef5;
  background: #fff;
}

.post-mass-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 2px 0;
}

.post-mass-actions__hint {
  font-size: 11px;
  color: #909399;
  margin-right: 12px;
}

.occurrence-icon {
  margin-left: 0.1rem;
  display: inline-block;
  width: 1.2em;
  text-align: center;
}
/* Frase única em um só tamanho; o número filtrado destaca por cor/peso */
.post-header__meta {
  font-size: 13px;
  color: #909399;
  margin-left: 6px;
}

.post-header__count {
  font-weight: 600;
  color: #22418d;
  font-variant-numeric: tabular-nums;
}
</style>